import { CssBaseline, Typography, Button } from "@mui/material";
import { Box } from "@mui/system";
import Layout from "@pages/Layout/layout";
import { useNavigate } from "react-router-dom";

const LogoutOnInactivityPage = () => {
  const navigate = useNavigate();
  return (
    <CssBaseline>
      <Layout user={{}}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "90vh",
            p: 2,
          }}
        >
          <Typography variant="body1" align="center">
            <div data-testid="logout-inactivity-text">
              You have been logged out due to inactivity
            </div>
            <Button variant="contained" onClick={() => navigate("/")}>
              Login
            </Button>
          </Typography>
        </Box>
      </Layout>
    </CssBaseline>
  );
};

export default LogoutOnInactivityPage;
